export const LIST_ADVISERS_REQUESTED = 'LIST_ADVISERS_REQUESTED';
export const LIST_ADVISERS_COMPLETED = 'LIST_ADVISERS_COMPLETED';
export const LIST_ADVISERS_FAILED = 'LIST_ADVISERS_FAILED';
export const LIST_ADVISERS_ABORTED = 'LIST_ADVISERS_ABORTED';

export const SET_ADVISER_REQUESTED = 'SET_ADVISER_REQUESTED';
export const SET_ADVISER_ABORTED = 'SET_ADVISER_ABORTED';
export const SET_ADVISER_COMPLETED = 'SET_ADVISER_COMPLETED';
export const SET_ADVISER_FAILED = 'SET_ADVISER_FAILED';

export const SEARCH_ADVISERS_REQUESTED = 'SEARCH_ADVISERS_REQUESTED';
export const SEARCH_ADVISERS_COMPLETED = 'SEARCH_ADVISERS_COMPLETED';
export const SEARCH_ADVISERS_FAILED = 'SEARCH_ADVISERS_FAILED';

export const GET_ADVISERS_USERS_REQUESTED = 'GET_ADVISERS_USERS_REQUESTED';
export const GET_ADVISERS_USERS_ABORTED = 'GET_ADVISERS_USERS_ABORTED';
export const GET_ADVISERS_USERS_COMPLETED = 'GET_ADVISERS_USERS_COMPLETED';
export const GET_ADVISERS_USERS_FAILED = 'GET_ADVISERS_USERS_FAILED';

export const RESET_ADVISER_REQUESTED = 'RESET_ADVISER_REQUESTED';
export const RESET_ADVISER_COMPLETED = 'RESET_ADVISER_COMPLETED';

export const RESET_ADVISER_LIST_REQUESTED = 'RESET_ADVISER_LIST_REQUESTED';
export const RESET_ADVISER_LIST_COMPLETED = 'RESET_ADVISER_LIST_COMPLETED';

export const CREATE_ADVISERS_USER_REQUESTED = 'CREATE_ADVISERS_USER_REQUESTED';
export const CREATE_ADVISERS_USER_ABORTED = 'CREATE_ADVISERS_USER_ABORTED';
export const CREATE_ADVISERS_USER_COMPLETED = 'CREATE_ADVISERS_USER_COMPLETED';
export const CREATE_ADVISERS_USER_FAILED = 'CREATE_ADVISERS_USER_FAILED';

export const RESEND_ADVISERS_USER_REQUESTED = 'RESEND_ADVISERS_USER_REQUESTED';
export const RESEND_ADVISERS_USER_ABORTED = 'RESEND_ADVISERS_USER_ABORTED';
export const RESEND_ADVISERS_USER_COMPLETED = 'RESEND_ADVISERS_USER_COMPLETED';
export const RESEND_ADVISERS_USER_FAILED = 'RESEND_ADVISERS_USER_FAILED';

export const CHANGE_ADVISERS_EMAIL_REQUESTED =
  'CHANGE_ADVISERS_EMAIL_REQUESTED';
export const CHANGE_ADVISERS_EMAIL_COMPLETED =
  'CHANGE_ADVISERS_EMAIL_COMPLETED';
export const CHANGE_ADVISERS_EMAIL_FAILED = 'CHANGE_ADVISERS_EMAIL_FAILED';
export const CHANGE_ADVISERS_PASSWORD_REQUESTED =
  'CHANGE_ADVISERS_PASSWORD_REQUESTED';
export const CHANGE_ADVISERS_PASSWORD_COMPLETED =
  'CHANGE_ADVISERS_PASSWORD_COMPLETED';
export const CHANGE_ADVISERS_PASSWORD_FAILED =
  'CHANGE_ADVISERS_PASSWORD_FAILED';

export const RESET_ADVISERS_TOAST_REQUESTED = 'RESET_ADVISERS_TOAST_REQUESTED';
export const RESET_ADVISERS_TOAST_COMPLETED = 'RESET_ADVISERS_TOAST_COMPLETED';
